<template>
  <div class="vx-card p-6">
    <h1 class=" text-center mb-5">
      Üretim Reçetesi Yönetimi
    </h1>
    <div class="vx-row w-full flex-no-wrap" >
      <div class="vx-col" style="width:350px">
        <div class="flex flex-wrap items-center" style="width:350px">
          <!-- ITEMS PER PAGE -->
          <div class="flex-grow">
            <vs-dropdown vs-trigger-click class="cursor-pointer">
              <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                <span class="mr-2">
                  {{ currentPage * paginationPageSize - (paginationPageSize - 1) }}
                  -
                  {{ productionList.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : productionList.length }}
                  of {{ productionList.length }}
                </span>
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>
              <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
              <vs-dropdown-menu>
                <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                  <span>10</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                  <span>20</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                  <span>25</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                  <span>30</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>
        </div>

        <div class="vx-row" style="width:350px">
          <div class="vx-col text-left" style="width:350px" >
            <ag-grid-vue
              ref="agGridTable"
              :gridOptions="gridOptions"
              class="ag-theme-material ag-grid-table"
              :columnDefs="columnDefs"
              :defaultColDef="defaultColDef"
              :rowData="productionList"
              rowSelection="single"
              colResizeDefault="shift"
              :animateRows="true"
              :floatingFilter="true"
              :pagination="true"
              :paginationPageSize="paginationPageSize"
              :suppressPaginationPanel="true"
              :rowClassRules="rowClassRules"
              @selectionChanged="selectionChanged"
            ></ag-grid-vue>
            <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
          </div>
        </div>
      </div>
      <div style="text-align: -webkit-center" class="flex w-full vx-col justify-center" v-if="selectedRow.productId">
        <vue-tree style="height: 800px; border: 1px solid gray;" :dataset="richMediaData" :config="treeConfig">
          <template v-slot:node="{ node, collapsed }">
            <div class="rich-media-node " :style="{ border: collapsed ? '2px solid grey' : '' }" v-if="node.value">
              <img
                :src="node.pngBase64 == null && node.fileName != null ? DocumentSystemGetImageStream(node) : node.pngBase64"
                style="width: 60px; height: 60px; border-raduis: 4px;"
                @click="
                  () => {
                    fileManagerPopupPropParent = true;
                    fileManagerPopupPropProductIdParent = node.value;
                  }
                "
              />
              <div class="justify-center">
                <div class="vx-row mt-2 danger ">
                  <span style=" font-weight: "> {{ node.title }}</span>
                </div>
                <div class="vx-row mt-2 danger justify-center">
                  <span style=" font-weight: "> {{ "Product Id : " + node.value }}</span>
                </div>
                <div class="vx-row mt-2 success font-bold justify-center">
                  <span> {{ " ( Miktar : " + node._amount + " )" }}</span>
                </div>
                <div class="vx-row mt-2 font-bold justify-center">
                  <feather-icon v-if="selectedRow.productId != node.value" class=" cursor-pointer danger" icon="MinusSquareIcon" @click="OperateReceipt('Subtract', node)" />
                  <feather-icon v-if="selectedRow.productId != node.value" class="ml-5 mr-5 cursor-pointer warning" icon="EditIcon" @click="OperateReceipt('Update', node)" />
                  <feather-icon
                    class="cursor-pointer success"
                    icon="PlusSquareIcon"
                    @click="
                      () => {
                        selectedNodeToAdd = node;
                        productSearchPopupParent = true;
                      }
                    "
                  />
                </div>
              </div>
            </div>
            <div v-else>
              <h3 class="text-center whitespace-no-wrap primary">
                {{ selectedRow.productName + " Üretimi" }}
              </h3>
            </div>
          </template>
        </vue-tree>
      </div>
    </div>
    <file-manager-popup
      v-if="fileManagerPopupPropParent"
      @FileManagerPopupClosedChildEmit="FileManagerPopupClosedParentEmitCatch($event)"
      :fileManagerPopupProp="fileManagerPopupPropParent"
      :moduleIdProp="fileManagerPopupPropProductIdParent"
      moduleNameProp="product"
    ></file-manager-popup>
    <product-search v-if="productSearchPopupParent" :productSearchPopupProp="productSearchPopupParent" @ProductSearchPopupClosedChildEmit="ProductSearchPopupClosedParent($event)"></product-search>
  </div>
</template>

<script>
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import vSelect from "vue-select";
import { repository } from "@/_services/repository.js";
import VueTree from "@ssthouse/vue-tree-chart";
import FileManagerPopup from "../../Tool/FileManagerPopup.vue";
import ProductSearch from "../../Search/ProductSearch.vue";

import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
// Cell Renderer
import CellRendererProduct from "./CellRenderer/CellRendererProduct.vue";

export default {
  name: "treemap",
  components: {
    vSelect,
    AgGridVue,
    VueTree,
    CellRendererProduct,
    FileManagerPopup,
    ProductSearch,
  },
  data() {
    return {
      selectedNodeToAdd: {},
      selectedProductToAdd: {},
      fileManagerPopupPropParent: false,
      fileManagerPopupPropProductIdParent: false,
      selectedRow: { productId: null, _amount: null },
      productSearchPopupParent: false,
      productionList: [],
      resultList: [],
      richMediaData: {},
      treeConfig: { nodeWidth: 120, nodeHeight: 80, levelHeight: 200 },

      gridOptions: { rowHeight: 40 },
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
      },

      columnDefs: [
        {
          headerName: "Üretilen Ürün Adı",
          field: "productName",
          filter: true,
          cellRendererFramework: "CellRendererProduct",
        },
      ],
    };
  },
  watch: {},

  computed: {
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 12;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      },
    },
  },

  created: async function() {
    this.GetProductForProduction();
  },

  methods: {
    FileManagerPopupClosedParentEmitCatch: async function(v) {
      this.fileManagerPopupPropParent = false;
    },

    ProductSearchPopupClosedParent: async function(v) {
      this.productSearchPopupParent = false;
      if (v && v.productId != null) {
        this.selectedProductToAdd = v;
        this.OperateReceipt("Add", this.selectedNodeToAdd);
      } else {
        null;
      }
    },

    OperateReceipt: async function(operation, item) {
      console.log(operation, item);

      item.operation = operation;

      if (operation == "Add") {
        let addConfirm = await this.$swal.fire({
          icon: "warning",
          title: "Devam etmek istediğiniz miktarı giriniz",
          html: "Reçete bulunan " + item.title + " ürününe üretim ürünü olarak " + this.selectedProductToAdd.productName + " eklenecektir. Miktar Giriniz " + '<br/><input id="swal-input1" type="number" class="swal2-input">',

          preConfirm: function() {
            var elm = document.getElementById("swal-input1");
            item._amount = elm.value;
          },
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Tamam",
          cancelButtonText: "İptal",
        });
        console.log(addConfirm);
        if (addConfirm.isConfirmed == true) null;
        else return;

        let addItem = { _amount: item._amount, _parentProductId: this.selectedNodeToAdd.value, value: this.selectedProductToAdd.productId, operation: operation };

        this.$vs.loading();
        await repository.postEntity("Production/OperateProductionReceipt", addItem);
        await this.$swal.fire({
          icon: "success",
          title: "İşlem Başarılı",
          //text: "",
          showCancelButton: false,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Tamam",
          cancelButtonText: "Hayır",
        });

        await this.GetProductionReceiptChart();
        this.$vs.loading.close();
      } else if (operation == "Update") {
        let updateConfirm = await this.$swal.fire({
          icon: "warning",
          title: "Güncellemek istediğiniz miktarı giriniz",
          //text: "Reçete bulunan " + item.title + " ürününün miktarı  güncellenecektir. Mevcut Miktar : " + item._amount,
          html: "Reçete bulunan " + item.title + " ürününün miktarı  güncellenecektir. Mevcut Miktar : " + item._amount + '<br/><input id="swal-input1" type="number" class="swal2-input">',

          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Tamam",
          cancelButtonText: "İptal",
          preConfirm: function() {
            var elm = document.getElementById("swal-input1");
            item._amount = elm.value;
          },
        });

        if (updateConfirm.isConfirmed == true) null;
        else return;

        this.$vs.loading();
        await repository.postEntity("Production/OperateProductionReceipt", item);
        await this.$swal.fire({
          icon: "success",
          title: "İşlem Başarılı",
          //text: "",
          showCancelButton: false,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Tamam",
          cancelButtonText: "Hayır",
        });

        await this.GetProductionReceiptChart();
        this.$vs.loading.close();
      } else if (operation == "Subtract") {
        let resultConfirm2 = await this.$swal.fire({
          icon: "warning",
          title: "Devam etmek istediğinize emin misiniz?",
          text: "Reçeteden ürün silinecektir.",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Evet",
          cancelButtonText: "Hayır",
        });

        if (resultConfirm2.isConfirmed) null;
        else return;

        this.$vs.loading();
        await repository.postEntity("Production/OperateProductionReceipt", item);
        await this.$swal.fire({
          icon: "success",
          title: "İşlem Başarılı",
          //text: "",
          showCancelButton: false,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Tamam",
          cancelButtonText: "Hayır",
        });

        await this.GetProductionReceiptChart();
        this.$vs.loading.close();
      }

      //this.productionList = await repository.postEntity("Production/OperateProductionReceipt", item).then((r) => r.list);
    },

    selectionChanged: async function() {
      this.selectedRow = this.gridApi.getSelectedRows()[0];

      await this.GetProductionReceiptChart();
    },
    getProductionById: async function() {
      this.productionList = await repository.postEntity("Production/GetProductionForStock", { productionId: this.productId }).then((r) => r.list);
    },

    GetProductForProduction: async function() {
      this.productionList = await repository.postEntity("Production/GetProductForProduction", { produceType: "Produce" }).then((r) => r.list);
    },

    GetProductionReceiptChart: async function() {
      this.resultList = await await repository.postEntity("Production/GetProductionReceiptChart", { productId: this.selectedRow.productId }).then((r) => r.list);

      //this.BindPictureRecursively(result.list);
      //console.log("resultListWithPhoto",resultListWithPhoto);

      this.richMediaData = { _key: -1, _amount: null, name: "", title: "Nitro Üretim Ağacı", value: null, avatar: null, children: this.resultList };
    },
  },
  beforeMount() {
    this.rowClassRules = {
      rowColorForNotWorkingPerson: "data.status == false",
      rowColorForMissingInfoPerson: "data.error != null",
    };
  },
  beforeUpdate() {
    this.gridApi.sizeColumnsToFit();
  },
  mounted() {
    this.gridApi = this.gridOptions.api;

    this.gridApi.sizeColumnsToFit();
  },
};
</script>
